import { goNextScreen, setReadyTriggerScreenOnReady } from './screenSlice'

export const screenMiddleware = (store) => {
    setTimeout(() => {
        store.dispatch(goNextScreen())
    }, 300)

    return next => (action) => {
        next(action)

        if (action.type === goNextScreen.toString()) {
            setTimeout(() => {
                store.dispatch(setReadyTriggerScreenOnReady())
            }, 1000)
        }
    }
}
